function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent } from "vue";
//@ts-ignore
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
import { getDefaultSearchBean } from "@wikicasa/common/model/RealEstateSearchBean";
import { COLORS, MAP_TILER_APIKEY } from "../../components/variables";
import LeafletMap from "@wkWebSrc/js/LeafletMap/leaflet_map";
import { LatLng } from "leaflet";
import { validateMap, parsePoints, getPolygonString } from "@utils/MapUtils";
import { ENERGY_CLASS } from "@customTypes/EnergyClass";
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
import { mapState, mapActions } from "pinia";
import { useBreakpoints } from "@wkComposables/useBreakpoints";
import { useSearch } from "@wkComposables/useSearch";
import { getPlace } from "@services/placesAPI";
//@ts-ignore
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
import { getPlacesAddressAutocomplete, getPlacesDetails, getAroundMePolygon } from "@services/geographyAPI";
import { GAutocompleteTypes } from "@customTypes/GAutocompleteTypes";
import { googlePlaceConverter } from "@utils/GAutocompleteUtils";
import { PLACE_TYPE } from "@customTypes/PlaceType";
import { getUserPosition, browserSupportGeolocation } from "@utils/GeolocationUtils";
import { useSearchBeanStore } from "@store/SearchBeanStore";
var USER_POSITION_ZOOM = 17;
var AROUNDME_POSITION_ZOOM = 13;
var DESKTOP_POSITION_ZOOM = 7;
var DEFAULT_POSITION = {
  lat: 41.902782,
  lng: 12.496366,
  zoom: 6
};
export default defineComponent({
  name: "MapModal",
  components: {
    BaseBtModal: BaseBtModal,
    BaseButton: BaseButton,
    BaseAlert: BaseAlert,
    BaseAutocomplete: BaseAutocomplete
  },
  props: {
    showMapModal: {
      type: Boolean,
      "default": false
    },
    listing: {
      type: Boolean
    },
    aroundMe: {
      type: Boolean,
      "default": false
    },
    previouslyAroundMe: {
      type: Boolean
    },
    place: {
      type: Object
    }
  },
  emits: ["emit-place", "hide-map-modal"],
  setup: function setup() {
    var _useBreakpoints = useBreakpoints(),
      isDesktopMode = _useBreakpoints.isDesktopMode,
      isLarge = _useBreakpoints.isLarge,
      isSmall = _useBreakpoints.isSmall;
    var _useSearch = useSearch(),
      search = _useSearch.search;
    return {
      isDesktopMode: isDesktopMode,
      isLarge: isLarge,
      isSmall: isSmall,
      //useSearch
      search: search
    };
  },
  data: function data() {
    return {
      searchBeanModal: getDefaultSearchBean(),
      mapDrawing: false,
      hasPolygon: false,
      center: DEFAULT_POSITION,
      mapPlace: null,
      map: null,
      idUserPositionMarker: 0,
      mapPositionMarker: 1,
      loadingAroundMePolygon: false,
      currentRadius: 0,
      //meters
      currentMapIDbase: "draw-on-mobile_",
      currentMapID: "draw-on-mobile_" + Date.now(),
      // userLocationError = false,
      mapError: false,
      mapWarning: false,
      labelText: "",
      loading: false,
      isPlace: false,
      openMapModal: false,
      pmCustomEvent: null,
      currentAddress: undefined,
      autocompleteDisabled: true
    };
  },
  computed: Object.assign({
    cdn: function cdn() {
      return window["_cdn"];
    },
    headerClasses: function headerClasses() {
      //@ts-ignore
      return this.isDesktopMode ? "tw-hidden" : "tw-pb-10px tw-pt-15px";
    },
    labels: function labels() {
      return window["_labels"];
    },
    currentRadiusKm: function currentRadiusKm() {
      if (!this.currentRadius) return 0;
      return this.currentRadius / 1000;
    },
    isDesktop: function isDesktop() {
      return window.screen.width > BREAKPOINT.SMALL;
    }
  }, mapState(useSearchBeanStore, ["searchBean"])),
  watch: {
    hasPolygon: function hasPolygon(cur, prev) {
      this.checkMapError();
    },
    mapPlace: function mapPlace(cur, prev) {
      var _a, _b, _c;
      (_a = this.map) === null || _a === void 0 ? void 0 : _a.startSpinner();
      (_b = this.map) === null || _b === void 0 ? void 0 : _b.setCenter(cur.latitude, cur.longitude, USER_POSITION_ZOOM);
      (_c = this.map) === null || _c === void 0 ? void 0 : _c.stopSpinner();
    },
    currentRadius: function currentRadius(cur, prev) {
      this.updateAroundMePolygon();
    }
  },
  created: function created() {
    this.openMapModal = this.showMapModal;
  },
  mounted: function mounted() {
    this.mapWarning = false;
    this.searchBeanModal = JSON.parse(JSON.stringify(this.searchBean));
    this.searchBeanModal.listingTypologyURL = window._listingTypologyURL;
    this.idUserPositionMarker = Date.now();
    this.convertEnergyClassFilter();
    this.convertFloor();
    this.onOpened();
  },
  methods: Object.assign({
    browserSupportGeolocation: browserSupportGeolocation,
    onInputChangeCb: function onInputChangeCb(query) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getPlacesAddressAutocomplete(query, 10, [GAutocompleteTypes.DRAWONMAP]);
            case 2:
              res = _context.sent;
              return _context.abrupt("return", res.map(function (r) {
                return {
                  label: r.description,
                  id: r.place_id
                };
              }));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    },
    optionSelectedCb: function optionSelectedCb(selectedEl) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var gPlaceDetails, curPlace, _currentAddress;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (selectedEl) {
                _context2.next = 3;
                break;
              }
              this.isPlace = false;
              return _context2.abrupt("return");
            case 3:
              //Removing the polygon iff there is a map error (e.g. area too large )
              !this.mapWarning && this.deletePolygon();
              _context2.next = 6;
              return getPlacesDetails("".concat(selectedEl === null || selectedEl === void 0 ? void 0 : selectedEl.id));
            case 6:
              gPlaceDetails = _context2.sent;
              _context2.next = 9;
              return googlePlaceConverter(gPlaceDetails, selectedEl.label);
            case 9:
              curPlace = _context2.sent;
              this.autocompleteDisabled = true;
              _currentAddress = "";
              try {
                if (curPlace.placeType == PLACE_TYPE.CITY && curPlace.streetName) {
                  _currentAddress = "".concat(curPlace.streetName);
                  if (curPlace.streetNumber) {
                    _currentAddress += " ".concat(curPlace.streetNumber);
                  }
                  if (curPlace.zip) {
                    _currentAddress += " ".concat(curPlace.zip);
                  }
                  _currentAddress += "".concat(curPlace.displayName).trim();
                } else _currentAddress = "".concat(curPlace.displayName).trim();
                this.currentAddress = {
                  label: _currentAddress
                };
              } catch (e) {
                this.currentAddress = {
                  label: "".concat(curPlace.displayName).trim()
                };
              }
              this.mapPlace = curPlace;
              this.isPlace = true;
              this.setCoordinates(this.mapPlace.latitude, this.mapPlace.longitude, USER_POSITION_ZOOM);
              this.updateMapCenter();
              (_a = this.map) === null || _a === void 0 ? void 0 : _a.addMarker(this.idUserPositionMarker, new LatLng(this.mapPlace.latitude, this.mapPlace.longitude));
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    },
    deletePolygonAndCloseModal: function deletePolygonAndCloseModal() {
      this.deletePolygon();
      this.closeMapModal();
    },
    onOpened: function onOpened() {
      this.initMap();
      if (this.aroundMe) return;
    },
    convertEnergyClassFilter: function convertEnergyClassFilter() {
      //@ts-ignore
      switch (this.searchBean.energyClassFilter) {
        case "HIGH":
          {
            this.searchBeanModal.energyClassFilter = ENERGY_CLASS.HIGH;
            break;
          }
        case "MEDIUM":
          {
            this.searchBeanModal.energyClassFilter = ENERGY_CLASS.MEDIUM;
            break;
          }
        case "LOW":
          {
            this.searchBeanModal.energyClassFilter = ENERGY_CLASS.LOW;
            break;
          }
      }
    },
    convertFloor: function convertFloor() {
      this.searchBeanModal.floor = this.searchBeanModal.floorId;
    },
    checkMapError: function checkMapError() {
      this.mapError = this.map ? !validateMap(this.map) : true;
      this.labelText = !this.aroundMe ? this.labels.mapTooLarge : this.labelText;
    },
    getPlaceFn: function getPlaceFn(query) {
      return getPlace(query);
    },
    setCoordinates: function setCoordinates(latitude, longitude, zoom) {
      this.center.lat = latitude;
      this.center.lng = longitude;
      this.center.zoom = zoom;
    },
    loadingMapAroundMe: function loadingMapAroundMe() {
      var _a, _b, _c, _d, _e;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var positionCb, position, pos;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              (_a = this.map) === null || _a === void 0 ? void 0 : _a.startSpinner();
              if (!this.currentRadius) this.currentRadius = 1000;
              _context3.prev = 2;
              positionCb = getUserPosition();
              if (positionCb) {
                _context3.next = 6;
                break;
              }
              throw new Error("Localitation not available");
            case 6:
              _context3.next = 8;
              return positionCb;
            case 8:
              position = _context3.sent;
              this.mapWarning = false;
              (_b = this.map) === null || _b === void 0 ? void 0 : _b.stopSpinner();
              pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              this.setCoordinates(pos.lat, pos.lng, AROUNDME_POSITION_ZOOM);
              this.updateMapCenter();
              //controllare se effettivamente serve
              if (!this.aroundMe) (_c = this.map) === null || _c === void 0 ? void 0 : _c.addMarker(this.idUserPositionMarker, pos);
              _context3.next = 17;
              return this.updateAroundMePolygon();
            case 17:
              _context3.next = 29;
              break;
            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3["catch"](2);
              console.error("user position errore", _context3.t0);
              //1 is permission denied
              if (_context3.t0.code == 1) {
                this.labelText = this.labels.positionNotAllowed;
              }
              // every other errors
              else {
                this.labelText = this.labels.errorTryAgain;
              }
              this.mapWarning = true;
              (_d = this.map) === null || _d === void 0 ? void 0 : _d.removeMarker(this.idUserPositionMarker);
              this.center.zoom = AROUNDME_POSITION_ZOOM;
              _context3.next = 28;
              return this.updateAroundMePolygon();
            case 28:
              (_e = this.map) === null || _e === void 0 ? void 0 : _e.stopSpinner();
            case 29:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 19]]);
      }));
    },
    updateAroundMePolygon: function updateAroundMePolygon() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.loadingAroundMePolygon = true;
              _context4.next = 3;
              return getAroundMePolygon(this.center.lat, this.center.lng, this.currentRadius);
            case 3:
              response = _context4.sent;
              _context4.prev = 4;
              if (response.data) {
                _context4.next = 7;
                break;
              }
              return _context4.abrupt("return");
            case 7:
              this.searchBeanModal.polygonFromMap = response.data;
              this.drawPolygon(response.data);
              _context4.next = 14;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](4);
              console.error(_context4.t0);
            case 14:
              _context4.prev = 14;
              this.loadingAroundMePolygon = false;
              return _context4.finish(14);
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[4, 11, 14, 17]]);
      }));
    },
    getPosition: function getPosition() {
      var _this = this;
      var _a, _b;
      (_a = this.map) === null || _a === void 0 ? void 0 : _a.startSpinner();
      (_b = getUserPosition()) === null || _b === void 0 ? void 0 : _b.then(function (position) {
        var _a, _b, _c;
        (_a = _this.map) === null || _a === void 0 ? void 0 : _a.stopSpinner();
        _this.mapWarning = false;
        _this.deletePolygon();
        var pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        _this.setCoordinates(pos.lat, pos.lng, USER_POSITION_ZOOM);
        _this.updateMapCenter();
        (_b = _this.map) === null || _b === void 0 ? void 0 : _b.addMarker(_this.idUserPositionMarker, pos);
        (_c = _this.map) === null || _c === void 0 ? void 0 : _c.stopSpinner();
      }, function (error) {
        var _a, _b;
        //map.setCenter(DEFAULT_POSITION.lat, DEFAULT_POSITION.lng, DEFAULT_POSITION.zoom);
        if (error.code == 1) {
          _this.labelText = _this.labels.positionNotAllowed;
        } else {
          _this.labelText = _this.labels.errorTryAgain;
        }
        _this.mapWarning = true;
        (_a = _this.map) === null || _a === void 0 ? void 0 : _a.removeMarker(_this.idUserPositionMarker);
        (_b = _this.map) === null || _b === void 0 ? void 0 : _b.stopSpinner();
      });
    },
    updateMapCenter: function updateMapCenter() {
      var _a, _b;
      (_a = this.map) === null || _a === void 0 ? void 0 : _a.removeMarker(this.idUserPositionMarker);
      (_b = this.map) === null || _b === void 0 ? void 0 : _b.setCenter(this.center.lat, this.center.lng, this.center.zoom);
    },
    initMap: function initMap() {
      var _this2 = this;
      var _a, _b;
      this.map = new LeafletMap();
      var map_selector = this.$refs.mapPlaceholder;
      (_a = this.map) === null || _a === void 0 ? void 0 : _a.init(map_selector, MAP_TILER_APIKEY, COLORS, {
        touch: !this.isLarge
      });
      (_b = this.map) === null || _b === void 0 ? void 0 : _b.ready(function () {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          var _this3 = this;
          var _c, _d, _e, isBgImageShown, removeBgImage;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.aroundMe) {
                  _context5.next = 5;
                  break;
                }
                _context5.next = 3;
                return this.loadingMapAroundMe();
              case 3:
                _context5.next = 6;
                break;
              case 5:
                if (!this.listing && this.previouslyAroundMe) {
                  this.searchBeanModal.polygonFromMap = "";
                  this.searchBeanModal.polygonForDB = "";
                  this.deletePolygon();
                } else if (this.searchBeanModal.polygonFromMap || this.searchBeanModal.polygonForDB) {
                  this.hasPolygon = true;
                  this.mapDrawing = true;
                  this.searchBeanModal.polygonForDB ? this.drawPolygon(this.searchBeanModal.polygonForDB) : this.drawPolygon(this.searchBeanModal.polygonFromMap);
                } else {
                  (_c = this.map) === null || _c === void 0 ? void 0 : _c.setCenter(this.center.lat, this.center.lng, window.screen.width > BREAKPOINT.SMALL ? DESKTOP_POSITION_ZOOM : this.center.zoom);
                  this.hasPolygon = false;
                  this.mapDrawing = false;
                }
              case 6:
                isBgImageShown = true;
                removeBgImage = function removeBgImage() {
                  if (!isBgImageShown) return;
                  map_selector.style.backgroundImage = "none";
                  isBgImageShown = false;
                };
                (_d = this.map) === null || _d === void 0 ? void 0 : _d.on("zoomstart", removeBgImage);
                (_e = this.map) === null || _e === void 0 ? void 0 : _e.on("draw:created", function () {
                  _this3.hasPolygon = true;
                });
              case 10:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
      });
    },
    drawPolygon: function drawPolygon(polygon) {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      var latLngs = parsePoints(polygon);
      if (latLngs) {
        if ((_a = this.map) === null || _a === void 0 ? void 0 : _a.getMap()) {
          (_b = this.map) === null || _b === void 0 ? void 0 : _b.deleteShape();
          (_d = (_c = this.map) === null || _c === void 0 ? void 0 : _c.getMap()) === null || _d === void 0 ? void 0 : _d.invalidateSize();
        }
        //@ts-ignore
        (_e = this.map) === null || _e === void 0 ? void 0 : _e.drawPolygonFromPoints(latLngs);
        (_f = this.map) === null || _f === void 0 ? void 0 : _f.fitBounds((_h = (_g = this.map) === null || _g === void 0 ? void 0 : _g.getShape()) === null || _h === void 0 ? void 0 : _h.getBounds());
      }
      this.checkMapError();
    },
    startDrawing: function startDrawing() {
      var _a;
      this.mapError = false;
      this.mapWarning = false;
      this.hasPolygon = false;
      this.mapDrawing = true;
      (_a = this.map) === null || _a === void 0 ? void 0 : _a.setDrawing();
    },
    deletePolygon: function deletePolygon() {
      var _a, _b;
      this.hasPolygon = false;
      this.mapError = false;
      this.mapDrawing = false;
      this.searchBeanModal.polygonFromMap = "";
      this.searchBeanModal.polygonForDB = "";
      this.updateSearchBean({
        polygonFromMap: "",
        polygonForDB: ""
      });
      (_a = this.map) === null || _a === void 0 ? void 0 : _a.deleteShape();
      (_b = this.map) === null || _b === void 0 ? void 0 : _b.stopDrawing();
    },
    confirmPolygon: function confirmPolygon() {
      var _a, _b;
      this.loading = true;
      this.checkMapError();
      if (this.mapError) {
        this.loading = false;
        return;
      }
      this.searchBeanModal.polygonForDB = getPolygonString((_a = this.map) === null || _a === void 0 ? void 0 : _a.getShapePoints());
      this.searchBeanModal.polygonFromMap = this.map ? (_b = this.map) === null || _b === void 0 ? void 0 : _b.getShapePoints().map(function (point) {
        return "".concat(point.lat, ",").concat(point.lng, ";");
      }).join("") : "";
      if (this.listing) {
        this.updateSearchBean({
          polygonForDB: this.searchBeanModal.polygonForDB,
          polygonFromMap: this.searchBeanModal.polygonFromMap,
          areaOfInterestId: undefined,
          areaId: undefined,
          placeType: undefined,
          placeId: undefined,
          zoneId: undefined,
          zoneIdList: [],
          localityIdList: [],
          districtIdList: [],
          districtId: undefined,
          cityId: undefined,
          provinceId: undefined,
          regionId: undefined,
          cityDisplayName: undefined,
          cityURL: undefined,
          zoneURL: undefined,
          streetURL: undefined
        });
        // BRUTAL FIX: previene il fatto che passi dal listato agenzia ad un listato real estate nella ricerca su mappa
        this.search(true, window.page_type == "Listato agenzie" ? "agenzie-immobiliari" : "", window.page_type !== "Listato agenzie");
      } else {
        this.loading = false;
        this.hasPolygon = true;
        this.mapDrawing = false;
        this.emitPlace();
      }
    },
    confirmAndSearchPolygon: function confirmAndSearchPolygon() {
      this.loading = true;
      this.confirmPolygon();
      this.loading = false;
    },
    closeMapModal: function closeMapModal() {
      this.pmCustomEvent = {
        type: "hide-map-modal"
      };
      this.openMapModal = false;
    },
    hideMapModal: function hideMapModal() {
      if (!this.pmCustomEvent) this.pmCustomEvent = {
        type: "hide-map-modal"
      };
      this.pmCustomEvent && this.$emit(this.pmCustomEvent.type, this.pmCustomEvent.payload);
    },
    emitPlace: function emitPlace() {
      this.pmCustomEvent = {
        type: "emit-place",
        payload: {
          aroundMe: this.aroundMe,
          radius: this.currentRadiusKm,
          polygon: this.searchBeanModal.polygonFromMap ? this.searchBeanModal.polygonFromMap : "",
          polygonForDB: this.searchBeanModal.polygonForDB ? this.searchBeanModal.polygonForDB : ""
        }
      };
      this.openMapModal = false;
    }
  }, mapActions(useSearchBeanStore, ["setSearchBean", "setSearchBeanByKey", "updateSearchBean"]))
});